import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';

class Results extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    var results = this.props.data.results;
    console.log(results[0]);
    let that = this;
    if(results.length){
      return (
        <div className="container-fluid" style={ { "padding": "0em", "margin-top": "85px" } }>
          {
            results.map(function(item){
              return(
                <div className="row result_card" style={{"padding": "1%"}}>
                  <div className="col-md-2 col-sm-2 col-xs-2">
                    <img className="img img-responsive img-rounded result_thumb" height="150" width="150" src={item.image} />
                  </div>

                  <div className="col-md-6 col-sm-6 col-xs-6 result_info">
                    <p style={{"font-size": "large","font-weight": "bold", "cursor": "pointer"}} onClick={() => that.getOffers(item.id)}>{item.title}</p>
                    <p>{item.cuisines.replace(/\"/g,"").split(",").join(" | ")}</p>
                    <p>{item.address}</p>
                  </div>
                </div>
              );
            })
          }
        </div>
        );
    }
    else {
      return (
        <div className="container-fluid" style={ { "padding": "0em", "margin-top": "85px" } }>
          <div style={{"margin": "0 auto", "width": "250px", "margin-top": "100px"}}>
            <p style={{"font-size": "large"}}>User id/details unavailable</p>
          </div>
        </div>
      )
    }
  }

  getOffers(id){
    window.location.href = '/offers/' + id;
  }
}

module.exports = Results;



// WEBPACK FOOTER //
// ./src/components/Results.js